import React,  { useEffect } from "react";
import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import HeaderOne from "../../components/layout/HeaderOne";
import Breadcrumb from "../../components/Breadcrumb";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import DynamicContent from "../../components/DynamicContent";
import { useParams } from "react-router-dom";
import usePageContentList from "../../hooks/usePageContentList";

const DynamicContentPage = () => {
  const { type } = useParams();

  const { fetchPageContentList, data, status, error, resetStatus } =
    usePageContentList();

  console.log("DynamicContentPage type:", type);

  const [addressEnum, setAddressEnum] = React.useState(0);

  const handleAddressEnumChange = (add) => {
    setAddressEnum(add);
  };

  useEffect(() => {
    if (type) {
      fetchPageContentList({ type, language: "en-US" });
    } else {
      console.error("Type is not provided in the URL parameters.");
    }
  }, [type]);

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#990A02" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={data && data[0]?.field} />

      {/* DynamicContent */}
      <DynamicContent  content={data && data[0]?.dataString} />

      {/* ShippingOne */}
      {/* <ShippingOne /> */}

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default DynamicContentPage;
